/**
 * Adventure World Card
 *
 * Displays a selectable world card for the adventure hub page.
 * Shows world name, theme icon, difficulty badge, and narrative preview.
 */

import React from 'react';

interface AdventureWorldCardProps {
  worldId: string;
  name: string;
  narrative: string;
  theme: string;
  difficulty: string;
  selected: boolean;
  onSelect: (worldId: string) => void;
}

const THEME_EMOJI: Record<string, string> = {
  fire: '\uD83C\uDF0B',
  ice: '\u2744\uFE0F',
  forest: '\uD83C\uDF32',
  dark: '\uD83C\uDF11',
  desert: '\uD83C\uDFDC\uFE0F',
  ocean: '\uD83C\uDF0A',
  mountain: '\u26F0\uFE0F',
};

const DIFFICULTY_COLORS: Record<string, string> = {
  beginner: '#4ade80',
  intermediate: '#fbbf24',
  advanced: '#f97316',
  expert: '#ef4444',
};

export const AdventureWorldCard: React.FC<AdventureWorldCardProps> = ({
  worldId,
  name,
  narrative,
  theme,
  difficulty,
  selected,
  onSelect,
}) => {
  return (
    <div
      className="world-card"
      onClick={() => onSelect(worldId)}
      style={{
        padding: '1rem',
        background: selected ? 'rgba(255, 215, 0, 0.15)' : 'rgba(255, 255, 255, 0.05)',
        border: selected ? '2px solid #FFD700' : '2px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        color: '#fff',
      }}
    >
      <div style={{ fontSize: '1.3rem', marginBottom: '0.25rem' }}>
        {THEME_EMOJI[theme] || '\u2694\uFE0F'} {name}
      </div>
      <div style={{
        display: 'inline-block',
        padding: '0.15rem 0.5rem',
        borderRadius: '4px',
        fontSize: '0.75rem',
        background: DIFFICULTY_COLORS[difficulty] || '#888',
        color: '#000',
        fontWeight: 'bold',
        marginBottom: '0.5rem',
      }}>
        {difficulty}
      </div>
      <p style={{
        fontSize: '0.85rem',
        color: 'rgba(255, 255, 255, 0.7)',
        margin: '0.5rem 0 0',
      }}>
        {narrative.length > 100 ? narrative.slice(0, 100) + '...' : narrative}
      </p>
    </div>
  );
};
